import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { DialogRef } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog-ref';
import { DIALOG_DATA } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog-tokens';
import { EcommerceStoreSelectionModalData } from '@api-ui-app/src/app/e-commerce-store-selection-modal/types/ecommerce-store-selection-modal-data';
import { EStore } from '@gelato-api-ui/core/e-commerce/e-store';

@Component({
  selector: 'gd-e-commerce-store-selection-modal',
  templateUrl: './e-commerce-store-selection-modal.component.html',
  styleUrls: ['./e-commerce-store-selection-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ECommerceStoreSelectionModalComponent {
  @Input() storesList: EStore[];

  @Output() storeSelect: EventEmitter<EStore> = new EventEmitter<EStore>();

  constructor(
    @Inject(DialogRef) private dialogReg: DialogRef<boolean>,
    @Inject(DIALOG_DATA) public dialogData: EcommerceStoreSelectionModalData,
  ) {}

  closeModal(): void {
    this.dialogReg.close();
  }

  selectStore(store: EStore) {
    this.storeSelect.emit(store);
    this.dialogData.selectStoreAction?.(store);
    this.closeModal();
  }
}
